import React, { useMemo, useEffect, useCallback } from 'react';
import { keyBy, get, isObject, set, isArray } from 'lodash';
import shallowEqual from 'shallowequal';
import FormTreeModalSelector from '../../../../controls/NextTree/FormTreeModalSelector';
import SubtreeValueView from '../../../../controls/ValueViews/SubtreeValueView';
import StaticOverlayTree from '../../../../dataViews/StaticOverlayTree';
import useEntityFormContext from '../../internal/useEntityFormContext';
import { isRootNode, } from '../../../../dataViews/DynamicTree/constants';
import Button from '../../../../controls/Button';
import useT from '../../../../utils/Translations/useT';
export default function TreeSelectorFieldContent({ isEditing, field, adapter, label, isLoading, models, plugins, selectionMode, tree, isRequired, isDisabled, name, formElement, clearOnTop = false, ...props }) {
    const t = useT();
    const { setFieldTouched, resetForm, dirty, values } = useEntityFormContext();
    const getNodeId = useCallback((model) => !isArray(model) && isObject(model) && (adapter === null || adapter === void 0 ? void 0 : adapter.resolveNodeId)
        ? adapter.resolveNodeId(model)
        : get(model, 'id'), [adapter]);
    const modelsHash = useMemo(() => keyBy(models, getNodeId), [
        models,
        getNodeId,
    ]);
    useEffect(() => {
        const entity = modelsHash[getNodeId(field.input.value)];
        if (entity &&
            field.input.value &&
            !shallowEqual(entity, field.input.value)) {
            if (!dirty) {
                const newValues = { ...values };
                set(newValues, name, entity);
                resetForm({ values: newValues });
            }
        }
    }, [
        field.input,
        field.input.onChange,
        field.input.value,
        modelsHash,
        getNodeId,
        dirty,
        setFieldTouched,
        name,
        resetForm,
        values,
    ]);
    if (isEditing) {
        return (<FormTreeModalSelector {...field} isRenderOnlySelected adapter={adapter} disabled={isDisabled} formElement={formElement} hasClearButton={!clearOnTop} label={label} loading={isLoading} models={models} required={isRequired} selection={field.input.value} selectionMode={selectionMode} {...props}>
        {({ models, selection, onSelectionChange }) => {
            const renderNodeAddons = (node, meta) => {
                const handleClear = () => {
                    onSelectionChange([]);
                };
                const handleClearFn = e => {
                    handleClear();
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                };
                const addons = [];
                if (isRootNode(node)) {
                    addons.push(<Button additionClasses="text-primary no-padding-top no-padding-bottom" buttonStyle="link" onClick={handleClearFn}>
                  {t('Clear')}
                </Button>);
                }
                return addons;
            };
            return (<StaticOverlayTree adapter={clearOnTop ? { ...adapter, renderNodeAddons } : { ...adapter }} plugins={plugins} selectionMode={selectionMode} staticModels={models} tree={tree} value={selection} onSelectionChange={onSelectionChange} {...props}/>);
        }}
      </FormTreeModalSelector>);
    }
    return (<SubtreeValueView adapter={adapter} label={label} models={models} selection={field.input.value} {...props}/>);
}
